import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCardImage,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
} from "mdbreact";
import logo from "../assets/logo.png";
import publishimg from "../assets/atk_kpru.png";
import banner_normal from "../assets/banner_normal1.png";
import banner_special from "../assets/banner_special1.png";
import banner_kru from "../assets/banner_kru1.png";
import banner_std_0 from "../assets/banner_std_0.png";
import banner_bundit from "../assets/banner_bundit1.png";
// import banner_normal from "../assets/banner_normal.png";
// import banner_special from "../assets/banner_special.png";
// import banner_kru from "../assets/banner_kru.png";
// import banner_bundit from "../assets/banner_bundit.png";
import btnprocedureregister from "../assets/btnprocedureregister.png";
import btncheckregister from "../assets/btncheckregister.png";
import btntuitionfee from "../assets/btntuitionfee.png";
// import btnmain from "../assets/btnmain.png";
import btnbackend from "../assets/btnbackend.png";
import btncalendar from "../assets/btncalendar.png";
import btnpresent from "../assets/btnpresent.png";
import btnscholarship from "../assets/btnscholarship.png";
import btnonlinescore from "../assets/btnonlinescore.png";
import btnscorenurse from "../assets/btnscorenurse.png";
import banner_logo from "../assets/banner_logo.png";
import banner_logo2 from "../assets/banner_logo2.png";
import report from "../assets/2024/report.png";
import Swal from "sweetalert2";
/// 2026
import normall from "../assets/2026/button/normall.png";
import weekend from "../assets/2026/button/weekend.png";
import teacher from "../assets/2026/button/teacher.png";
import bundit from "../assets/2026/button/bundit.png";
import assist from "../assets/2026/button/assist.png";
import bnr1 from "../assets/2026/btn/bnr1.png";
import bnr2 from "../assets/2026/btn/bnr2.png";
import btn1 from "../assets/2026/btn/btn1.png";
import btn2 from "../assets/2026/btn/btn2.png";
import btn3 from "../assets/2026/btn/btn3.png";
import btn4 from "../assets/2026/btn/btn4.png";
import btn5 from "../assets/2026/btn/btn5.png";
import btn6 from "../assets/2026/btn/btn6.png";
import btn7 from "../assets/2026/btn/btn7.png";
import btn8 from "../assets/2026/btn/btn8.png";
import btn9 from "../assets/2026/btn/btn9.png";
import btn10 from "../assets/2026/btn/btn10.png";
import btn11 from "../assets/2026/btn/btn11.png";
export default class Home_newlastbee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenWidth: 0,
      screenWidthbanner: 0,
      modalshow: true,
    };
    this.modalshow_close = this.modalshow_close.bind(this);
  }

  componentDidMount() {
    localStorage.clear();
    if (window.screen.width < 800) {
      this.setState({ screenWidth: window.screen.width - 120 });
      this.setState({ screenWidthbanner: window.screen.width - 70 });
    } else {
      this.setState({ screenWidth: window.screen.width * 0.19 });
      this.setState({ screenWidthbanner: window.screen.width * 0.19 });
    }
    // documen
    // document.body.style.background = "#ff0f80";
    // document.body.style.background = "#ffd7ba";
    document.body.style.background = "#58c5b0";
    // document.body.style.background = "#7de2d1";
    document.body.style.background = "#ebebebff";
    // document.body.style.background = "linear-gradient(90deg, #fffae5 0%, #ffe566 50%, #fffae5 100%)";
    // document.body.style.background = "linear-gradient(90deg, #ff850cff 0%, #ffe566 50%, #fac800ff 100%)";
    // document.body.style.background = "linear-gradient(90deg, #ff0f80 10%, #89fc00 50%, #FF5C00 100%)";
    // document.body.style.background = " radial-gradient(circle,#ff850cff 19%, #fffae5 88%)";
    // document.body.style.backgroundColor = "blue";
    let [day, month, year] = ["25", "04", "2025"];
    let [days, months, years] = ["22", "04", "2025"];
    if (parseInt(year) > 2400) {
      year = (parseInt(year) - 543).toString();
    }
    const textDate = `${month}/${day}/${year} 23:59`;
    const textDates = `${months}/${days}/${years} 23:59`;
    const startdate = new Date(textDate);
    const enddate = new Date(textDates);
    const datenow = new Date();
    if (startdate <= datenow && datenow <= enddate) {
      console.log("มากกว่า");
      Swal.fire({
        // icon: "info",
        html: "<div style='font-size:24px;' >  <div style='font-size:22;color:#0077b6;font-weight:700;'>ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์กศ.บป. </div> <div style='font-size:22;color:#0077b6;font-weight:700;'>วันที่ 26 เม.ย. 68 เวลา 18.00 น.</div></div>",
        confirmButtonText: "ดูผล",
        // confirmButtonText: "แบบฟอร์มรายงานผลตรวจร่างกาย",
        // confirmButtonText: "ตกลง",
        // cancelButtonText: "ประกาศรายชื่อ",
        // cancelButtonText: "ประกาศรายชื่อ",
        // showCancelButton: true,
        showConfirmButton: true,
        showCloseButton: true,
        cancelButtonColor: "green",
        confirmButtonColor: "#5a189a",
        // timer: 10000,
        // timerProgressBar: true,
      }).then((res) => {
        console.log(res);
        if (res.isConfirmed === true) {
          // setTimeout(() => {
          //   //   // window.location.href =  "http://localhost:3000/admission/Checkregister/2"
          //   //   // window.location.href =  "http://10.1.210.85:3000/admission/Checkregister/2"
          window.location.href = "https://admission.kpru.ac.th/admission/Checkregister/2";
          // }, 200);
        } else if (res.dismiss === "cancel") {
          // window.location.href =
          //   "https://admission.kpru.ac.th/admission2017/public/news/1742526562.pdf";
        }
      });
      return true;
    } else {
      console.log("น้อยกว่า");
      return false;
    }

    // Swal.fire({
    //   html: "<div style='font-size:20px;' >  <div style='font-size:18;color:#0077b6;font-weight:700;'>ประกาศรายชื่อผู้ผ่านการคัดเลือก(ทะเบียนสำรอง)  </div> <div style='font-size:18;color:#0077b6;font-weight:700;'>คณะพยาบาลศาสตร์</div></div>",
    //   confirmButtonText: "แบบฟอร์มรายงานผลตรวจร่างกาย",
    //   // confirmButtonText: "ตกลง",
    //   cancelButtonText: "ประกาศรายชื่อ",
    //   showCancelButton: true,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   cancelButtonColor: "green",
    //   confirmButtonColor: "#5a189a",
    //   // timer: 2000,
    //   // timerProgressBar: true,
    // }).then((res) => {
    //   console.log(res)
    //   if (res.isConfirmed === true) {
    //     // setTimeout(() => {
    //     //   //   // window.location.href =  "http://localhost:3000/admission/Checkregister/2"
    //     //   //   // window.location.href =  "http://10.1.210.85:3000/admission/Checkregister/2"
    //     window.location.href = "https://admission.kpru.ac.th/admission/Checkregister/2";
    //     // }, 200);
    //   } else if (res.dismiss === "cancel") {
    //     window.location.href =
    //       "https://admission.kpru.ac.th/admission2017/public/news/1742526562.pdf";
    //   }
    // });
  }

  modalshow_close(e) {
    this.setState({ modalshow: false });
  }

  render() {
    return (
      <>
        <MDBContainer className="text-center px-1 glass pt-2 mt-2 pb-3">
          <MDBRow
            className="mt-3 px-5"
            style={
              {
                // borderRadius: "10px",
                // backgroundColor: "#ffffff20",
                // boxShadow: "0px 0px 10px #00000020",
              }
            }
          >
            <img
              src={bnr1}
              style={{ borderRadius: "10px" }}
              className="w-100 d-none d-md-block"
              onClick={() => {
                window.open("https://admission.kpru.ac.th/admission/Register/1");
              }}
            />
            <img
              src={bnr2}
              style={{ borderRadius: "10px", cursor: "pointer" }}
              className="w-100 d-md-none d-block"
              onClick={() => {
                window.open("https://admission.kpru.ac.th/admission/Register/1");
              }}
            />
          </MDBRow>
          <MDBRow className="mt-3 px-5 home-bg  " style={{ borderRadius: "10px" }}>
            <MDBCol className="m-0 p-0 col-lg col-12 ">
              <a href={`${process.env.REACT_APP_BASENAME || ""}/Procedureregister`}>
                <img alt="" src={btn1} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </MDBCol>
            <MDBCol className="m-0 p-0 mx-lg-4 my-lg-0 my-3 col-lg col-12  ">
              <a href={`${process.env.REACT_APP_BASENAME || ""}/Checkregister/2`}>
                <img alt="" src={btn2} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </MDBCol>
            <MDBCol className="m-0 p-0 col-lg col-12  ">
              <a href={`${process.env.REACT_APP_BASENAME || ""}/Tuitionfee`}>
                <img alt="" src={btn3} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </MDBCol>
          </MDBRow>
          <MDBRow className="mt-3 px-5 home-bg  " style={{ borderRadius: "10px" }}>
            <MDBCol className="m-0 p-0 col-lg col-12 ">
              <a href={`${process.env.REACT_APP_BASENAME || ""}/Calendars`}>
                <img alt="" src={btn4} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </MDBCol>
            <MDBCol className="m-0 p-0 mx-lg-4 my-lg-0 my-3 col-lg col-12">
              <a href={`${process.env.REACT_APP_BASENAME || ""}/Checkpresent`}>
                <img alt="" src={btn5} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </MDBCol>
            <MDBCol className="m-0 p-0 col-lg col-12  ">
              <a href={`${process.env.REACT_APP_BASENAME || ""}/Scholarship`}>
                <img alt="" src={btn6} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </MDBCol>
          </MDBRow>
          <div className="d-flex flex-wrap">
            <a href={`${process.env.REACT_APP_BASENAME || ""}/Register/1`} className="col-lg-6 col-12 ">
              <img alt="" src={normall} style={{ borderRadius: "10px" }} width="100%" />
            </a>
            <a href={`${process.env.REACT_APP_BASENAME || ""}/Register/2`} className="col-lg-6 col-12">
              <img alt="" src={weekend} style={{ borderRadius: "10px" }} width="100%" />
            </a>
            <a href={`${process.env.REACT_APP_BASENAME || ""}/select-bundit`} className="col-lg-6 col-12">
              <img alt="" src={bundit} style={{ borderRadius: "10px" }} width="100%" />
            </a>
            <a href={`${process.env.REACT_APP_BASENAME || ""}/Register/5`} className="col-lg-6 col-12">
              <img alt="" src={teacher} style={{ borderRadius: "10px" }} width="100%" />
            </a>
            <a href={`${process.env.REACT_APP_BASENAME || ""}/Register/0`} className="col-lg-6 col-12">
              <img alt="" src={assist} style={{ borderRadius: "10px" }} width="100%" />
            </a>
          </div>

          <MDBRow className="px-5" style={{ borderRadius: "10px" }}>
            {/* <MDBCol xl="4" md="6" sm="12" className="mt-2 p-0 pr-1">
              <a href={`${process.env.REACT_APP_BASENAME || ""}/Calendars`}>
                <img alt="" src={btncalendar} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </MDBCol>
            <MDBCol xl="4" md="6" sm="12" className="mt-2 p-0 px-1">
              <a href={`${process.env.REACT_APP_BASENAME || ""}/Checkpresent`}>
                <img alt="" src={btnpresent} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </MDBCol>
            <MDBCol xl="4" md="6" sm="12" className="mt-2 p-0 pl-1 ">
              <a href={`${process.env.REACT_APP_BASENAME || ""}/Scholarship`}>
                <img alt="" src={btnscholarship} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </MDBCol> */}
            <div className="d-flex flex-row flex-wrap " style={{ gap: 0 }}>
              <a
                href="https://admission.kpru.ac.th/admission-teacher/login"
                target="_blank"
                className="p-2 col-12 col-sm-4"
              >
                <img alt="" src={btn7} style={{ borderRadius: "10px" }} width="100%" />
              </a>
              <a
                href="https://admission.kpru.ac.th/admission-faculty/login"
                target="_blank"
                className="p-2 col-12 col-sm-4"
              >
                <img alt="" src={btn11} style={{ borderRadius: "10px" }} width="100%" />
              </a>
              <a
                href="https://admission.kpru.ac.th/administrator-system/"
                target="_blank"
                className="p-2 col-12 col-sm-4"
              >
                <img alt="" src={btn8} style={{ borderRadius: "10px" }} width="100%" />
              </a>
              <a
                href="https://admission.kpru.ac.th/onlinescore/#/"
                target="_blank"
                className="p-2 col-12 col-sm-4"
              >
                <img alt="" src={btn9} style={{ borderRadius: "10px" }} width="100%" />
              </a>
              <a
                href="https://admission.kpru.ac.th/nurse_interviwe2022/"
                target="_blank"
                className="p-2 col-12 col-sm-4"
              >
                <img alt="" src={btn10} style={{ borderRadius: "10px" }} width="100%" />
              </a>
            </div>
          </MDBRow>
          {/* <Dialog
            width={"clamp(375px,90vw,800px)"}
            // hasFooter={false}
            isShown={this.state.modalshow}
            shouldCloseOnOverlayClick={false}
            className="pt-0"
           cancelLabel="ปิด"
           confirmLabel="ตรวจสอบ"
          >
            <div className="d-flex flex-column">
               <Text fontFamily="" fontSize="clamp(12px,2vw,18px)" >
              ประกาศผลการคัดเลือกตัวสำรองผู้เข้าศึกษาต่อภาคปกติ
              หลักสูตรครุศาสตรบัณฑิต 
            </Text>
               <Text fontFamily="" fontSize="clamp(12px,2vw,18px)" >
               และ ผู้มีสิทธิ์เข้าศึกษาคณะพยาบาลศาสตร์
              หลักสูตรพยาบาลศาสตรบัณฑิต
            </Text>
            </div>
           
          </Dialog> */}
          <MDBModal
            isOpen={false}
            // isOpen={this.state.modalshow}
            toggle={this.modalshow_close}
            centered
            dark
            size="lg"
            closeButton
            noClickableBodyWithoutBackdrop={true}
          >
            <MDBModalHeader toggle={this.modalshow_close}>
              ประกาศมหาวิทยาลัยราชภัฏกำแพงเพชร
            </MDBModalHeader>
            <MDBModalBody className="#bdbdbd grey lighten-1">
              <img alt="" src={publishimg} width="100%" />
            </MDBModalBody>
            <MDBModalFooter>
              <button class="btn btn-danger btn-md" onClick={this.modalshow_close}>
                ปิด
              </button>
            </MDBModalFooter>
          </MDBModal>
        </MDBContainer>
      </>
    );
  }
}


